export default "__VITE_ASSET__UoAj2f7g__"